import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=eead8478&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eead8478')) {
      api.createRecord('eead8478', component.options)
    } else {
      api.reload('eead8478', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=eead8478&", function () {
      api.rerender('eead8478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/comp/stardisplay.vue"
export default component.exports